export enum EnumDocumentType {
    PDF = 'PDF',
    EXCEL = 'EXCEL',
    TEMPLATE = 'TEMPLATE'
}
